'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-slick/lib/index.js
 ** module id = 1080
 ** module chunks = 0
 **/